import { useEffect, useState } from 'react'

import { containsSensitiveContent } from '@/utils/check-sensitive-content'

export function useContentModeration(text: string) {
  const [debouncedText, setDebouncedText] = useState(text)

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedText(text)
    }, 500)

    return () => clearTimeout(timer)
  }, [text])

  const isFlagged = debouncedText === text && containsSensitiveContent(text)

  return { isFlagged }
}
